import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import autoCategoryTypes from './dictionaries/auto_category_types_store';
import autoNumberValidateStore from './dictionaries/auto_number_validate_store';
import documentTypes from './dictionaries/document_types_store';
import excludeModule from './dictionaries/exclude_module_for_using_extra_car_fields';
import franchiseTypes from './dictionaries/franchise_types';
import insuranceParametersStore from './dictionaries/insurance_parameters_store';
import otkTypes from './dictionaries/otk_types_store';
import passportCenters from './dictionaries/passport_centers';
import periodTypes from './dictionaries/periods_store';
import userTypesTariff from './dictionaries/user_types_tariff_store';
import zoneTypes from './dictionaries/zone_types';
import authorization from './modules/authorization_store';
import bannersStore from './modules/banners_store';
import carsStore from './modules/cars_store';
import clientStore from './modules/client/client_store';
import clientBonusStore from './modules/client_bonus_store';
import orderStore from './modules/order_store';
import osagoStore from './modules/osago/osago_store';
import penaltyStore from './modules/penalty_store';
import profileInfo from './modules/profileInfo_store';
import newTariffItem  from './modules/tariffs/new_tariff_store';
import transactionsStore from './modules/transactions_store';
import partners from './modules/userData/partner_store';
import userSettings from './modules/userData/settings_store';
import userInfo from './modules/userInfo_store';
import { activityTypeModule } from '@/entities/activity-type';
import { clientModule } from '@/entities/client';
import { currentPageModule } from '@/entities/current-page';
import {
  affectingFactorsModule,
  paymentLinkModule,
  paymentSystemsModule,
  petsModule,
  petsOffersModule,
} from '@/entities/insurance';
import { layoutModule } from '@/entities/layout';
import { notificationModule } from '@/entities/notification';
import { partnersListModule } from '@/entities/partner';
import { textBlocksModule } from '@/entities/text-block';
import {
  currentUserModule,
  loginModule,
  registerModule,
  resetLinkEmailModule,
} from '@/entities/user';
import {
  accountBalanceModule,
  accountBonusesModule,
  withdrawalRequestModule
} from '@/features/account-balance';
import { advertisementBannersModule } from '@/features/advertise-banner';
import { lastNewsModule } from '@/features/last-news';
import {
  statisticInsuranceCompaniesModule,
  statisticOrdersModule,
  statisticPartnersModule,
  statisticProductsModule,
  statisticSummaryModule,
} from '@/features/order-statistics';
import { agentResourcesModule } from '@/features/agent-resources';
import { ordersHistoryModule } from '@/features/orders-history';
import { paymentStatusModule } from '@/features/payment-status';
import { telegramBotModule } from '@/features/telegram-bot';
import {
  promoAnimationsModule,
  promoCompanyProductsModule,
  promoFeedbacksModule,
  promoInsuranceIntermediaryModule,
  promoPresentationRequestsModule,
} from '@/features/promo';
import { ordersProlongationModule } from '@/features/renewals';
import {
  cityModule,
  companyBranchesModule,
  policyholderModule,
  vehicleModule
} from '@/features/selectors';
import { serverNotificationsModule } from '@/features/server-notifications';
import {
  activeTasksModule,
  archivedTasksModule,
} from '@/features/tasks';
import accountCashHistory from '@/store/dictionaries/account_cash_history';
import clientStatuses from '@/store/dictionaries/clients_tabs_store';
import companiesInfo from '@/store/dictionaries/companies_info_store';
import companyStartDate from '@/store/dictionaries/company_start_date';
import customerTypes from '@/store/dictionaries/customer_types_store';
import externalCompanyStore from '@/store/dictionaries/external_company_store';
import HomeInsuranceTypes from '@/store/dictionaries/insurance_home_types';
import knowledgeBaseStatuses from '@/store/dictionaries/knowledge_base_statuses';
import linksStore from '@/store/dictionaries/links_store';
import orderStatuses from '@/store/dictionaries/order_statuses_store';
import orderTypes from '@/store/dictionaries/order_types_store';
import periodActsGenetereStore from '@/store/dictionaries/period_acts_generate_store';
import privilegeTypes from '@/store/dictionaries/privilege_types_store';
import prolongStatuses from '@/store/dictionaries/prolong_statuses_store';
import activityTypesStore from '@/store/dictionaries/user_activity_types_store';
import userRecipientTypes from '@/store/dictionaries/user_recipient_types_store';
import userTypes from '@/store/dictionaries/user_types_store';
import levelsStore from '@/store/modules/bonusSystem/levels_store';
import missionsStore from '@/store/modules/bonusSystem/missions_store';
import BusInsuranceCompanyStore from '@/store/modules/bus_insurance_company_store';
import displaySettingsStore from '@/store/modules/display_settings_store';
import GreenCardInsuranceCompanyStore from '@/store/modules/greencard_insurance_company_store';
import HomeInsuranceCompanyStore from '@/store/modules/home_insurance_company_store';
import newsStore from '@/store/modules/news_store';
import tourismStore from '@/store/modules/tourism/tourism_store';
import accidentCalculationModule from '@/store/modules/accident/accidentCalculationModule';

// initial state
let initialState = {
  penaltyStore: { ...penaltyStore.state },
  partners: { ...partners.state },
  carsStore: { ...carsStore.state },
  userInfo: { ...userInfo.state },
  authorization: { ...authorization.state },
  osagoStore: { ...osagoStore.state },
  clientStore: { ...clientStore.state },
  profileInfo: { ...profileInfo.state },
  orderStore: { ...orderStore.state },
  transactionsStore: { ...transactionsStore.state },
  bannersStore: { ...bannersStore.state },
  clientBonusStore: { ...clientBonusStore.state },
  BusInsuranceCompanyStore: { ...BusInsuranceCompanyStore },
  GreenCardInsuranceCompanyStore: { ...GreenCardInsuranceCompanyStore },
  HomeInsuranceCompanyStore: { ...HomeInsuranceCompanyStore },
  tourismStore: { ...tourismStore.state },
  accidentCalculationModule: { ...accidentCalculationModule.state },

  currentUser: { ...currentUserModule.state },
  currentPage: { ...currentUserModule.state },
  partnersList: { ...partnersListModule.state },
  statisticSummaries: { ...statisticSummaryModule.state },
  statisticOrders: { ...statisticOrdersModule.state },
  statisticPartners: { ...statisticPartnersModule.state },
  statisticInsuranceCompanies: { ...statisticInsuranceCompaniesModule.state },
  statisticProducts: { ...statisticProductsModule.state },
  ordersHistoryList: { ...ordersHistoryModule.state },
  ordersProlongationList: { ...ordersProlongationModule.state },
  notifications: { ...notificationModule.state },
  lastNews: { ...lastNewsModule.state },
  activeTasks: { ...activeTasksModule.state },
  archivedTasks: { ...archivedTasksModule.state },
  accountBalance: { ...accountBalanceModule.state },
  accountBonuses: { ...accountBonusesModule.state },
  layout: { ...layoutModule.state },
  withdrawalRequests: { ...withdrawalRequestModule.state },
  serverNotifications: { ...serverNotificationsModule.state },
  promoAnimations: { ...promoAnimationsModule.state },
  textBlocks: { ...textBlocksModule.state },
  promoFeedbacks: { ...promoFeedbacksModule.state },
  promoPresentationRequests: { ...promoPresentationRequestsModule.state },
  promoInsuranceIntermediary: { ...promoInsuranceIntermediaryModule.state },
  promoCompanyProducts: { ...promoCompanyProductsModule.state },
  login: { ...loginModule.state },
  resetLinkEmail: { ...resetLinkEmailModule.state },
  register: { ...registerModule.state },
  activityType: { ...activityTypeModule.state },
  policyholder: { ...policyholderModule.state },
  vehicle: { ...vehicleModule.state },
  city: { ...cityModule.state },
  pets: { ...petsModule.state },
  petsOffers: { ...petsOffersModule.state },
  paymentSystems: { ...paymentSystemsModule.state },
  paymentLink: { ...paymentLinkModule.state },
  client: { ...clientModule.state },
  affectingFactors: { ...affectingFactorsModule.state },
  advertisementBanners: { ...advertisementBannersModule.state },
  companyBranches: { ...companyBranchesModule.state },
  paymentStatus: { ...paymentStatusModule.state },
  telegramBot: { ...telegramBotModule.state },
  agentResources: { ...agentResourcesModule.state },
};


Vue.use(Vuex);

export default new Vuex.Store({
  state: {

  },
  mutations: {
    reset (state) {
      //TODO решить почему это не работаетж
      Object.keys(initialState).forEach(key => {
        Object.assign(state[key], initialState[key]);
      });
    }
  },
  actions: {

  },
  getters: {

  },
  modules: {
    partners, userInfo, authorization, osagoStore, clientStore, profileInfo, documentTypes,
    orderStore, transactionsStore, bannersStore, clientBonusStore, newTariffItem,
    autoCategoryTypes, userTypesTariff, otkTypes, zoneTypes, excludeModule, periodTypes, franchiseTypes,
    orderStatuses, clientStatuses, orderTypes, carsStore, customerTypes, privilegeTypes, userSettings,
    passportCenters, insuranceParametersStore, autoNumberValidateStore, companiesInfo, userTypes, userRecipientTypes,
    accountCashHistory, companyStartDate, newsStore, BusInsuranceCompanyStore, GreenCardInsuranceCompanyStore, tourismStore, accidentCalculationModule,
    levelsStore, missionsStore, displaySettingsStore, activityTypesStore, periodActsGenetereStore, penaltyStore, externalCompanyStore,
    HomeInsuranceCompanyStore, HomeInsuranceTypes, linksStore, knowledgeBaseStatuses, prolongStatuses, currentUserModule,
    statisticSummaryModule, statisticOrdersModule, partnersListModule, statisticPartnersModule, statisticInsuranceCompaniesModule,
    statisticProductsModule, ordersHistoryModule, ordersProlongationModule, notificationModule, lastNewsModule,
    activeTasksModule, archivedTasksModule, accountBalanceModule, accountBonusesModule, layoutModule, withdrawalRequestModule,
    currentPageModule, serverNotificationsModule, promoAnimationsModule, textBlocksModule, promoFeedbacksModule,
    promoPresentationRequestsModule, promoInsuranceIntermediaryModule, promoCompanyProductsModule, loginModule,
    resetLinkEmailModule, registerModule, activityTypeModule, policyholderModule, vehicleModule, cityModule,
    advertisementBannersModule, clientModule, affectingFactorsModule, companyBranchesModule,
    paymentLinkModule, paymentSystemsModule, petsModule, petsOffersModule,
    paymentStatusModule, telegramBotModule, agentResourcesModule,
  },
  plugins: [
    createPersistedState({
      paths: ['osagoStore', 'clientStore', 'userInfo', 'userTypes', 'userRecipientTypes', 'newTariffItem',
          'BusInsuranceCompanyStore', 'GreenCardInsuranceCompanyStore', 'tourismStore', 'HomeInsuranceCompanyStore', 'accidentCalculationModule']
    }),
  ]

});
